import { render } from "./AppSidebar.vue?vue&type=template&id=66ca9fef"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=66ca9fef&lang=scss"
script.render = render

export default script